
export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b82aa2497c362173dcf4585d9db432af.jpg"
          alt="Desguace profesional en Castelldefels"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 sm:py-32 text-center">
        <div className="inline-flex items-center gap-2 px-3 sm:px-4 py-2 bg-white/90 backdrop-blur-sm text-teal-700 rounded-full mb-4 sm:mb-6">
          <i className="ri-shield-check-line text-base sm:text-lg"></i>
          <span className="text-xs sm:text-sm font-semibold whitespace-nowrap">COMPRAMOS COCHES SINIESTRADOS</span>
        </div>

        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-4 sm:mb-6 leading-tight">
          Vender Coche Siniestrado<br />
          <span className="text-teal-400">en Castelldefels</span>
        </h2>

        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/95 mb-3 sm:mb-4 max-w-3xl mx-auto leading-relaxed px-2">
          Compramos tu coche siniestrado al mejor precio. Recogida gratuita, pago inmediato y gestión de baja incluida.
        </p>
        
        <p className="text-sm sm:text-base md:text-lg text-white/90 mb-6 sm:mb-10 max-w-2xl mx-auto px-2">
          No importa el estado: accidentado, averiado o para desguace. Te damos una valoración en menos de 1 hora.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mb-8 sm:mb-12 px-4">
          <a
            href="#valoracion"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-teal-600 text-white rounded-full text-base sm:text-lg font-semibold hover:bg-teal-700 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-calculator-line text-xl sm:text-2xl"></i>
            Valoración Gratuita
          </a>
          <a
            href="tel:932932913"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 sm:gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-white text-gray-900 rounded-full text-base sm:text-lg font-semibold hover:bg-gray-100 transition-all shadow-xl hover:shadow-2xl hover:scale-105 whitespace-nowrap"
          >
            <i className="ri-phone-line text-xl sm:text-2xl"></i>
            932 932 913
          </a>
        </div>

        {/* Trust Indicators */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 sm:gap-6 max-w-4xl mx-auto px-2">
          <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-white/20">
            <div className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-500/20 rounded-full mx-auto mb-2 sm:mb-4">
              <i className="ri-money-euro-circle-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-xl font-bold text-white mb-1 sm:mb-2">Pago Inmediato</h3>
            <p className="text-white/80 text-xs sm:text-sm">Efectivo o transferencia al instante</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-white/20">
            <div className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-500/20 rounded-full mx-auto mb-2 sm:mb-4">
              <i className="ri-truck-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-xl font-bold text-white mb-1 sm:mb-2">Recogida Gratis</h3>
            <p className="text-white/80 text-xs sm:text-sm">Grúa incluida sin coste adicional</p>
          </div>

          <div className="bg-white/10 backdrop-blur-md rounded-xl sm:rounded-2xl p-4 sm:p-6 border border-white/20">
            <div className="w-10 h-10 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-500/20 rounded-full mx-auto mb-2 sm:mb-4">
              <i className="ri-file-text-line text-2xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-base sm:text-xl font-bold text-white mb-1 sm:mb-2">Gestión de Baja</h3>
            <p className="text-white/80 text-xs sm:text-sm">Tramitamos toda la documentación</p>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - Hidden on mobile */}
      <div className="absolute bottom-6 sm:bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden sm:block">
        <a
          href="#valoracion"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById('valoracion')?.scrollIntoView({ behavior: 'smooth' });
          }}
          className="flex flex-col items-center gap-2 text-white/80 hover:text-white transition-colors cursor-pointer"
        >
          <span className="text-sm font-medium whitespace-nowrap">Solicita tu valoración</span>
          <i className="ri-arrow-down-line text-2xl animate-bounce"></i>
        </a>
      </div>
    </section>
  );
}
